import Button from "@mui/material/Button";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type GuideLinkProps = {
  to: string;
  label?: string;
};

export const GuideLink: FC<GuideLinkProps> = ({
  to,
  label = "View guide",
}) => {
  const navigate = useNavigate();

  return (
    <Button
      fullWidth
      variant="text"
      color="primary"
      size="small"
      sx={{ mt: 0, mb: 1, textTransform: "none" }}
      onClick={() => navigate(to)}
    >
      {label}
    </Button>
  );
};
